<template>
  <div style="width:100%;float:left;">
    <CCard style="height:100%;" border-color="warning">
      <CCardHeader color="gradient-warning" text-color="white">{{title}}</CCardHeader>
      <CCardBody>
        <label style="width:100%;text-align:center;color:#ccc;">Click row to go to order.</label>
        <div v-if="data" style="width:100%;float:left;height:300px;overflow-y: scroll;">
          <table class="table">
            <thead>
              <tr>
                <th>Log#</th>
                <th>Cust#</th>
                <!-- <th>Style</th> -->
                <!-- <th>Program</th> -->
                <th v-if="type === 'ship_date'">Ship Date</th>
                <th v-if="type === 'event_date'">Event Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="val in data" style="cursor:pointer;" @click="goTo(val)" class="tableRow">
                <td>{{val.as400_log_number}}</td>
                <td>{{val.customer_number}}</td>
                <!-- <td>{{val.style_name}}</td> -->
                <!-- <td>{{val.program_name}}</td> -->
                <td v-if="type === 'ship_date'">{{configureMonthDate(val.ship_date)}}</td>
                <td v-if="type === 'event_date'">{{configureMonthDate(val.event_date)}}</td>
                <td>{{val.as400_status}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <small-loader v-else></small-loader>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
var methods = {}

methods.getData = function () {
  const postData = {
    csr: this.csr,
    type: this.type
  }
  axios.post(this.$apiAdress + '/api/orders/getUpcoming?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    this.data = response.data
  }).catch(e => {
    console.log(e)
  })
}

methods.configureMonthDate = function (date) {
  var date = moment(date).format('MM-DD')
  return date
}

methods.goTo = function (val) {
  this.$router.push('/order/' + val.order_id)
}

export default {
    // ===Component name
    name: "UpcomingOrders",
    // ===Props passed to component
    props: ['csr', 'title', 'type'],
    // ===Components used by this component
    components: {

    },
    // ====component Data properties
    data(){
        return{
          data: null
        }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
      this.getData()
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped lang="scss">
  .tableRow {
    &:hover {
      background-color:#ccc;
    }
  }
</style>
